module.exports = __webpack_public_path__ + "static/media/quadrature-ico.422e2c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/quadrature-ico.png
// module id = 714
// module chunks = 0